import PropTypes from "prop-types";
import React from "react";
import { Box, Flex, Image, Title, useMantineTheme } from "@mantine/core";
import { BorderedContent } from "./BorderedContent";
import CustomButton from "./mantineCustomComponents/CustomButton";
import EnhancedErrorDisplay from "./EnhancedErrorDisplay";
import { useStylesStampResult } from "../utils/mantine/useStylesStampResult";
import { useStylesPage } from "../utils/mantine/useStylesPage";

const StampError = ({ error, staticBasePath, handleDefaultScreen }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesStampResult } = useStylesStampResult();
  const { classes: classesPage } = useStylesPage();

  return (
    <Box
      className={`${classesStampResult.stamp} ${classesPage.page} stamp-result`}
    >
      <Image
        src={`${staticBasePath}public/images/svg/vb-icon-not-verified.svg`}
        alt="Error"
        className={classesPage.pageHeaderIcon}
      />

      <Title order={1}>ERROR: No Stamp Made</Title>

      <BorderedContent>
        <EnhancedErrorDisplay error={error} />
      </BorderedContent>

      <Flex
        align={theme.flex.align.center}
        justify={theme.flex.justify.center}
        mt={theme.margin.xxlEm}
        gap={theme.flex.gap.xs}
      >
        <CustomButton
          text="Make Another Stamp"
          onClick={handleDefaultScreen}
          componentClasses="buttonBlack buttonBlack-verify anchor"
        />
      </Flex>
    </Box>
  );
};

StampError.propTypes = {
  error: PropTypes.oneOfType([
    // Structured format from backend
    PropTypes.shape({
      error: PropTypes.shape({
        user_message: PropTypes.string.isRequired,
        technical_details: PropTypes.shape({
          message: PropTypes.string,
          timestamp: PropTypes.string,
          parameters: PropTypes.object,
        }),
      }),
    }),
    // Fallback: string or any other format (for backward compatibility)
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  staticBasePath: PropTypes.string.isRequired,
  handleDefaultScreen: PropTypes.func.isRequired,
};

export default StampError;
